import React, {useEffect, useState} from "react";
import useSpotGroupService from "../../api/services/useSpotGroupService";
import {default as MediaElement} from "../Media/Media";
import BookableStatus from "../BookableStatus/BookableStatus";
import Loading from "../Loading/Loading";
import Button from "../Button/Button";
import {Link} from "react-router-dom";
import bookingIcon from "../../assets/icons/booking-white.svg";
import boostIcon from "../../assets/icons/profile-boost-white.svg";
import cogIcon from "../../assets/icons/cog.svg";


const SpotGroupTileList = () => {

  const {userShowCollection} = useSpotGroupService()
  const [spotGroups, setSpotGroups] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    userShowCollection(
      (data) => {
        setSpotGroups(data || [])
        setIsLoading(false)
      },
      () => setIsLoading(false),
    )
  }, [])

  if (isLoading) return <Loading/>

  if (spotGroups.length === 0) {
    return <p className="empty-state">Je hebt nog geen locaties aangemaakt.</p>
  }

  return (
    <div className="component-spot-group-tile-list">
      {spotGroups.map((spotGroup) => (
        <div key={spotGroup.id} className="spot-group-tile">
          <Link to={spotGroup.slug ? '/locatie/' + spotGroup.slug : '/user/locatie/' + spotGroup.id + '/edit'} className="tile-main">
            <div className="tile-image">
              {spotGroup.overview_media
                ? <MediaElement media={spotGroup.overview_media} size="tile"/>
                : <div className="no-image">📍</div>
              }
            </div>
            <div className="tile-info">
              <h3>{spotGroup.label}</h3>
              <BookableStatus bookable={spotGroup}/>
              {spotGroup.spot_count > 0 &&
                <p className="tile-meta">{spotGroup.spot_count} standplaats{spotGroup.spot_count !== 1 ? 'en' : ''}</p>
              }
            </div>
          </Link>

          <div className="tile-actions">
            <div className="tile-buttons">
              <Button label="Boekingen" size="s" color="green" icon={bookingIcon} link={'/user/locatie/' + spotGroup.id + '/manager'}/>
              <Button label="Omhoog" size="s" color="blue" icon={boostIcon} link={'/user/profile-boosts'}/>
            </div>

            <div className="tile-quick-links">
              <Link to={'/user/locatie/' + spotGroup.id + '/edit'} className="quick-link" title="Instellingen">
                <img src={cogIcon} alt="Instellingen"/>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SpotGroupTileList
